import React, { useEffect, useState } from 'react';
import { getConsent, setConsent } from '../lib/metaPixel';

const TEXTS = {
  fr: { title: 'Cookies', body: "Nous utilisons des cookies publicitaires (Pixel Meta) pour mesurer l'efficacité de nos publicités Facebook et Instagram. Le suivi anonyme des visites reste actif dans tous les cas.", accept: 'Accepter', refuse: 'Refuser', more: 'En savoir plus' },
  de: { title: 'Cookies', body: 'Wir verwenden Werbe-Cookies (Meta-Pixel), um die Wirkung unserer Facebook- und Instagram-Werbung zu messen. Die anonyme Besuchsstatistik bleibt immer aktiv.', accept: 'Akzeptieren', refuse: 'Ablehnen', more: 'Mehr erfahren' },
  it: { title: 'Cookie', body: "Utilizziamo cookie pubblicitari (Pixel Meta) per misurare l'efficacia delle nostre pubblicità su Facebook e Instagram. Il conteggio anonimo delle visite resta sempre attivo.", accept: 'Accetta', refuse: 'Rifiuta', more: 'Maggiori informazioni' },
  en: { title: 'Cookies', body: 'We use advertising cookies (Meta Pixel) to measure the performance of our Facebook and Instagram ads. Anonymous visit statistics remain active in all cases.', accept: 'Accept', refuse: 'Decline', more: 'Learn more' },
};

const lang = () => {
  const l = (document.documentElement.lang || navigator.language || 'fr').slice(0, 2).toLowerCase();
  return TEXTS[l] ? l : 'fr';
};

export const openCookieSettings = () => window.dispatchEvent(new Event('ledzone-open-cookies'));

export const CookieBanner = () => {
  const [open, setOpen] = useState(() => !getConsent());
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener('ledzone-open-cookies', show);
    return () => window.removeEventListener('ledzone-open-cookies', show);
  }, []);
  if (open === false || window.location.search.includes('page=admin')) return null;
  const t = TEXTS[lang()];
  const choose = (v) => { setConsent(v); setOpen(false); };
  const btn = 'flex-1 sm:flex-none h-10 px-6 rounded-lg text-sm font-semibold border border-white/25 bg-white/10 text-white hover:bg-white/20 transition-colors';
  return (
    <div className="fixed inset-x-0 bottom-0 z-[70] p-3 sm:p-4" role="dialog" aria-label={t.title} data-testid="cookie-banner">
      <div className="keep-dark max-w-3xl mx-auto bg-[#111]/95 backdrop-blur-xl border border-white/10 rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row gap-3 sm:items-center shadow-2xl">
        <p className="text-xs sm:text-sm text-zinc-300 flex-1 leading-relaxed" data-testid="cookie-banner-text">
          {t.body}{' '}
          <a href="/?page=confidentialite" className="underline text-zinc-100" data-testid="cookie-banner-more">{t.more}</a>
        </p>
        <div className="flex gap-2">
          <button onClick={() => choose('denied')} className={btn} data-testid="cookie-refuse">{t.refuse}</button>
          <button onClick={() => choose('granted')} className={btn} data-testid="cookie-accept">{t.accept}</button>
        </div>
      </div>
    </div>
  );
};
